export default __webpack_public_path__ + "static/blob3-be89558cb7bce18586d790d797b89682.svg";